import DOMPurify from 'isomorphic-dompurify';

const options = {
	ALLOWED_TAGS: [
		// text formatting
		'a',
		'b',
		'br',
		'i',
		'em',
		'strong',
		's',
		'strike',
		'del',
		'u',
		// block elements
		'p',
		'div',
		'span',
		// lists
		'ul',
		'ol',
		'li',
		'pre',
		// code blocks
		'code',
		'blockquote',
	],
	ALLOWED_ATTR: [
		'href',
		'target',
		'rel', // link attributes
		'class', // for styling
	],
};

export const useSanitizeRichText = (text: string) => DOMPurify.sanitize(text, options);
